import { render, staticRenderFns } from "./RequiredIconCom.vue?vue&type=template&id=a2af60c2&scoped=true"
var script = {}
import style0 from "./RequiredIconCom.vue?vue&type=style&index=0&id=a2af60c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2af60c2",
  null
  
)

export default component.exports